import api from '../utils/api';

class SettingApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/settings', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getGroup = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/settings/group');
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/settings/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/settings', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  ClearProducts = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/settings/clear/product', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  ClearCategories = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/settings/clear/categories', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  ClearAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/settings/clear/all', data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/settings/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const setiingApi = new SettingApi();
export default setiingApi;
